// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VideoPlayer__container-d31c12 {
  display: flex;
  justify-content: center;
  position: relative;
  height: 100%;
  width: 100%;
}

.VideoPlayer__container-d31c12.VideoPlayer__inactive-b7f19d {
  cursor: none;
}

.VideoPlayer__video-c2636a {
  max-width: 100%;
  height: auto;
  max-height: 100%;
  outline: none;
}

.VideoPlayer__video-c2636a.VideoPlayer__mini-d62f98 {
  max-height: 400px;
}

.VideoPlayer__controls-e14313 {
  display: none;
}

.VideoPlayer__container-d31c12.VideoPlayer__active-bc8680 .VideoPlayer__controls-e14313,
.VideoPlayer__container-d31c12:hover .VideoPlayer__controls-e14313 {
  display: block;
}

.VideoPlayer__container-d31c12.VideoPlayer__inactive-b7f19d .VideoPlayer__controls-e14313 {
  display: none;
}

.VideoPlayer__container-d31c12:focus-within .VideoPlayer__controls-e14313 {
  display: block;
}

.VideoPlayer__actions-panel-ebbe1b {
  display: flex;
  justify-content: space-between;
}

.VideoPlayer__actions-a07d9c {
  display: flex;
  align-items: center;
  gap: 24px;
}

.VideoPlayer__action-button-af975b {
  color: var(--addition-50);
}

.VideoPlayer__action-button-af975b:focus-visible {
  color: var(--ib-color-hover); /* TODO: change design */
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/Media/VideoPlayer/VideoPlayer.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;;EAEE,cAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,4BAAA,EAAA,wBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  justify-content: center;\n  position: relative;\n  height: 100%;\n  width: 100%;\n}\n\n.container.inactive {\n  cursor: none;\n}\n\n.video {\n  max-width: 100%;\n  height: auto;\n  max-height: 100%;\n  outline: none;\n}\n\n.video.mini {\n  max-height: 400px;\n}\n\n.controls {\n  display: none;\n}\n\n.container.active .controls,\n.container:hover .controls {\n  display: block;\n}\n\n.container.inactive .controls {\n  display: none;\n}\n\n.container:focus-within .controls {\n  display: block;\n}\n\n.actions-panel {\n  display: flex;\n  justify-content: space-between;\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n}\n\n.action-button {\n  color: var(--addition-50);\n}\n\n.action-button:focus-visible {\n  color: var(--ib-color-hover); /* TODO: change design */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `VideoPlayer__container-d31c12`,
	"inactive": `VideoPlayer__inactive-b7f19d`,
	"video": `VideoPlayer__video-c2636a`,
	"mini": `VideoPlayer__mini-d62f98`,
	"controls": `VideoPlayer__controls-e14313`,
	"active": `VideoPlayer__active-bc8680`,
	"actions-panel": `VideoPlayer__actions-panel-ebbe1b`,
	"actionsPanel": `VideoPlayer__actions-panel-ebbe1b`,
	"actions": `VideoPlayer__actions-a07d9c`,
	"action-button": `VideoPlayer__action-button-af975b`,
	"actionButton": `VideoPlayer__action-button-af975b`
};
module.exports = ___CSS_LOADER_EXPORT___;
